if (window.location.href.includes("/pages/applications-assistant")) {
  let currentStep = 0;
  let selections = [];
  let answers = [];
  function normalizeKey(str) {
    return str
      .normalize("NFD")
      .replace(/[̀-\u036f]/g, "")
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9 ]/g, "")
      .replace(/\s+/g, "-");
  }
  const assistantData = (() => {
    const rawData = JSON.parse(document.querySelector("#applications-assistant-data").textContent);
    function get(path) {
      return path.reduce((acc, key) => acc && acc[key], rawData);
    }
    function currentQuestion(data) {
      if (!data || typeof data !== "object") return null;
      return Object.keys(data).find(k => k.endsWith("?"));
    }

    function currentAnswers(data, question) {
      const answerSet = data[question];
      if (!answerSet || typeof answerSet !== "object") return [];
      return Object.entries(answerSet).map(([label, value]) => {
        return {
          id: typeof value === "string" ? value : label,
          label
        };
      });
    }

    return {
      get,
      raw: rawData,
      applications: () => Object.keys(rawData),
      types: app => {
        const appData = rawData[app];
        if (!appData || typeof appData !== "object") return [];
        return Object.keys(appData).filter(k => !k.endsWith("?"));
      },
      currentQuestion,
      currentAnswers
    };
  })();

  function renderStep(step) {
    const stepEl = document.querySelector(`.aa-step--${step}`);
    if (!stepEl) return;

    let html = "";

    if (step === 0) {
      const apps = assistantData.applications().map(app => ({
        title: app,
        image: window.ApplicationsAssistant.images.applications[normalizeKey(app)]
      }));

      html = apps.map(app => `
        <div class="pblock pblock--title-inside">
          <div class="pblock__wrap">
            <div class="pblock__image">
              <a href="#" class="selection" data-type="application" data-value="${app.title}">
                <img src="${app.image}" alt="${app.title}" />
              </a>
            </div>
            <div class="pblock__title">${app.title}</div>
          </div>
        </div>
      `).join("");
    } else if (step === 1) {
      const selectedApp = selections[0];
      const types = assistantData.types(selectedApp);
      const templateScript = document.querySelector("#applications-assistant-types");
      if (templateScript && window.Handlebars) {
        const template = Handlebars.compile(templateScript.innerHTML);
        html = template(types);
      }
    } else if (step === 2) {
      const path = [...selections, ...answers];
      const data = assistantData.get(path);      
      if (typeof data === "string") {
        window.location.href = data;
        return;
      }

      const question = assistantData.currentQuestion(data);

      if (!question) {
        html = `<p><strong>Sorry!</strong> No recommended products found for your selections.</p>`;
      } else {
        const answersArray = assistantData.currentAnswers(data, question);
        const templateScript = document.querySelector("#applications-assistant-questions");

        if (templateScript && window.Handlebars) {
          const template = Handlebars.compile(templateScript.innerHTML);
          html = template({ [question]: answersArray });
        }
      }
    }
    const stepTitles = [
      "Select your application",
      "Select your applications type",
      "Answer these questions to get your recommended products"
    ];
    stepEl.innerHTML = `<div class="aa-block-wrap">${html}</div>`;

    // Set global title outside section
    const globalTitle = document.querySelector(".aa-title");
    if (globalTitle) {
      globalTitle.textContent = stepTitles[step] || "";
    }
    updateStepDisplay(step);
  }
  function updateStepDisplay(step) {
    document.querySelectorAll(".aa-step").forEach((el, i) => {
      el.style.display = i === step ? "block" : "none";
    });
    document.querySelectorAll(".aa-steps__item").forEach((el, i) => {
      el.classList.toggle("aa-steps__item--active", i === step);
    });
    const stepsEl = document.querySelector(".aa");
    if (stepsEl) {
      window.scrollTo({ top: stepsEl.offsetTop - 100, behavior: "smooth" });
    }
  }
  function handleSelection(el) {
    const type = el.dataset.type;
    const value = el.dataset.value;

    if (type === "application") {
      selections = [value];
      answers = [];
      currentStep = assistantData.types(value).length > 0 ? 1 : 2;
      renderStep(currentStep);
    } else if (type === "option") {
      selections[1] = value;
      answers = [];
      currentStep = 2;
      renderStep(currentStep);
    }
  }
  document.addEventListener("click", e => {
    const sel = e.target.closest(".selection");
    if (sel) {
      e.preventDefault();
      handleSelection(sel);
    }
  });
  document.addEventListener("click", e => {
  const answerBtn = e.target.closest(".answer");
  if (answerBtn) {    
    const questionEl = answerBtn.closest(".aa-question");
    const question = questionEl.querySelector(".aa-asking").dataset.question;
    const answer = answerBtn.textContent.trim(); // 👈 get actual label, not data-value
    answers.push(question);
    answers.push(answer);
    const path = [...selections, ...answers];
    const data = assistantData.get(path);    
    if (typeof data === "string") {      
      window.location.href = data;
    } else {      
      renderStep(2);
    }
  }
});
document.addEventListener("click", e => {
  if (e.target.closest("#backBtn")) {
    if (currentStep === 2) {
      if (answers.length >= 2) {
        // Go back one question
        answers.pop();
        answers.pop();        
        renderStep(2);
      } else {
        // If no answers yet, go back to step 1 or 0 depending on whether types exist
        const hasTypes = assistantData.types(selections[0]).length > 0;
        currentStep = hasTypes ? 1 : 0;
        renderStep(currentStep);
      }
    } else if (currentStep === 1) {
      currentStep = 0;
      renderStep(currentStep);
    }
  }
});
  renderStep(currentStep);
}
